import type { LegalBlock, LegalDocument, LegalSection } from '../../types/legal';
import { SitePageHero } from '../site/SitePageHero';

interface LegalDocumentViewProps {
  document: LegalDocument;
}

function Block({ block }: { block: LegalBlock }) {
  if (block.type === 'p') {
    return <p dangerouslySetInnerHTML={{ __html: block.html }} />;
  }
  return (
    <ul>
      {block.items.map((item: string) => (
        <li key={item.slice(0, 40)} dangerouslySetInnerHTML={{ __html: item }} />
      ))}
    </ul>
  );
}

export function LegalDocumentView({ document: doc }: LegalDocumentViewProps) {
  return (
    <>
      <SitePageHero tag="Legal" title={doc.title} subtitle={`Effective date: ${doc.effectiveDate}`} />

      <section className="site-legal">
        <div className="container">
          <div className="site-legal__body">
            {doc.preamble.length > 0 && (
              <article className="site-legal__card">
                {doc.preamble.map((paragraph: string) => (
                  <p key={paragraph.slice(0, 48)} dangerouslySetInnerHTML={{ __html: paragraph }} />
                ))}
              </article>
            )}

            {doc.sections.map((section: LegalSection) => (
              <article key={section.title} className="site-legal__card">
                <h3>{section.title}</h3>
                {section.blocks.map((block: LegalBlock, i: number) => (
                  <Block key={`${section.title}-${i}`} block={block} />
                ))}
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
